
import { useState } from 'react';
import { Product } from '@/lib/supabase/products/types';
import { toast } from 'sonner';
import { OrderFormData } from './types';
import { submitOrder } from './orderSubmissionHelper';

export const useOrderFormSubmit = (
  product: Product, 
  organizationId: string | null,
  shopId?: string
) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (
    e: React.FormEvent,
    formData: OrderFormData,
    resetForm: () => void
  ) => {
    e.preventDefault();
    
    // Log debug information
    console.log("Données de commande:", { 
      product_id: product.id, 
      product_name: product.name,
      organization_id: organizationId, 
      shopId, 
      customerName: formData.customerName, 
      customerPhone: formData.customerPhone 
    });
    
    if (!product) {
      toast.error("Produit non disponible pour la commande");
      return;
    }
    
    try {
      setSubmitting(true);
      
      // Call the submitOrder helper function
      const result = await submitOrder(product, organizationId, shopId, formData);
      
      if (result) {
        toast.success("Commande placée avec succès!");
        resetForm();
      }
    } catch (error) {
      console.error("Erreur lors de la création de la commande:", error);
      toast.error(error instanceof Error ? error.message : "Erreur lors de la création de la commande");
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    handleSubmit
  };
};
